import React, { useEffect, useState, useRef } from "react";
import { useSelector } from 'react-redux';
import { Drawer, Spin, List, Avatar, Row, Col, Card, Button, Tooltip, Input, Layout, Modal, message, Dropdown, Space, Typography } from "antd";
import { CloseOutlined, HomeOutlined, ArrowLeftOutlined, TableOutlined, FileExcelOutlined, BarChartOutlined, FilePdfOutlined } from "@ant-design/icons";

// Servicios
import { getProyectosPO, getComponentesPO, getDataProyectos } from '../../services/plaOperativo/planOperativoProyectosServices';
import { getPOPeso, getPOPesoResumen } from '../../services/plaOperativo/headerPlanOperativoServices';
import { viewFile } from '../../services/planesPedagogicos/planPedagogicoDowService';
import { fetchPoaData } from '../../services/poa/get_poa';
import getInformeFinalPlanOperativo from '../../services/plaOperativo/informeFinalPlanOperativoService';

// Selectores y store
import { selectAppPermissions, selectUserApplications } from '../../store/auth/selectors';

// Componentes propios
import ImageComponent from '../imageMapping/ImageComponent';
import PoaPlanOperativoTB from './PoaPlanOperativoTable';
import FileManagerPOA from '../Poa/FileManagerPOA.jsx';
import Participantes from '../Participantes/Participantes';
import Ippta from '../Ippta/Ippta';
import Edah from '../EncuestaEdah/Edah';
import AcuerdosComerciales from '../../components/AcuerdosComerciales/AcuerdosComerciales';
import DashboardPlanOperativo from './DashboardPlanOperativo';
import TablaAvanceJSX from './TablaResumenAvance.jsx';
import ExportPoa from './ExportablePOA';
import PoaResumen from './PoaResumen';
import RepositorioDocumento from '../Inicio/Repositorio/RepositorioDocumento.jsx';
import ManifestacionInteres from './ManifestacionInteres';
import InfraestructuraModal from "../Infraestructura/InfraestructuraModal.jsx"
import { getDirectoryTreePoaPP } from '../../services/plaOperativo/planOperativoProyectosServices';
import FileManagerPP from './FileManagerPP';
import { ProjectDashboard } from "../ReporteFAOPlanOperativo/ProjectDashboard"
import Novedades from '../ParticipanteNovedad/NovedadesPage';
import EcasParticipante from '../ParticipanteEcas/ECATable';
import InformeTecnicoFinalPage from '../InformeTecnicoFinal/InformeTecnicoFinalPage';


import { useLocation } from "react-router-dom";


const { Title, Text } = Typography

const PoaPlanOperativo = () => {

    const location = useLocation();
    const segments = location.pathname.replace("/planOperativo", "").split("/").filter(Boolean);
    let id = null;
    let tarea = null;
    let participanteFinal = null;
    let manifestacionInteres = null;
    let infraestructura = null;
    let infraestructuraItem = null;
    let novedades = null;
    let ecasParticipante = null;
    let documentoSoporte = null;

    if (segments.length >= 1) {
        id = segments[0];
    }

    if (segments.length >= 2) {
        if (segments[1] === "infraestructura") {
            infraestructura = "infraestructura";
        } else if (segments[1] === "participanteFinales") {
            participanteFinal = "participanteFinales";
        } else if (segments[1] === "manifestacionInteres") {
            manifestacionInteres = "manifestacionInteres";
        } else if (segments[1] === "novedades") {
            novedades = "novedades";
        } else if (segments[1] === "ecasParticipante") {
            ecasParticipante = "ecasParticipante";
        } else if (segments[1] === "documentoSoporte") {
            documentoSoporte = "documentoSoporte";
        }
        else {
            tarea = segments[1];
        }
    }


    if (segments.length >= 3) {
        infraestructura = segments[2];
    }

    if (segments.length >= 4) {
        infraestructuraItem = segments[3];
    }
    const isValid = (v) => v !== null && v !== undefined && v !== "";
    const [estadoIniciar, setEstadoIniciar] = useState(() => infraestructura === "infraestructura");
    const [isModalVisibleFileManager, setIsModalVisibleFileManager] = useState(false);
    const [dataFilterProyecto, setDataFilterProyecto] = useState(null);
    // Distingue si el Modal de FileManagerPP (compartido entre el deep-link
    // genérico de tareas y la tarjeta "Informe Final") se abrió para el
    // Informe Técnico Final, para habilitar ahí la exportación de árbol.
    const [esInformeFinalFileManager, setEsInformeFinalFileManager] = useState(false);
    const [banderaLink, setBanderaLink] = useState(false);
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectProject, setSelectedProject] = useState(null);
    const [selectedComponent, setSelectedComponent] = useState(null);
    const [componentes, setComponentes] = useState([]);
    const [error] = useState(null);
    const [isModalVisible2, setIsModalVisible2] = useState(false);
    const [selectedFase2, setSelectedFase2] = useState(null);
    const [codigoProyecto, setCodigoProyecto] = useState(null);
    const [codProyecto, setCodProyecto] = useState(null);
    const [isModalVisibleParticipantes, setIsModalVisibleParticipantes] = useState(false);
    const [openModalVisitasEcas, setOpenModalVisitasEcas] = useState(false);
    const [itemParams, setItemParams] = useState(false);
    const [opcionFiltro, setOpcionFiltro] = useState(null);
    const [, setLoadingComponentes] = useState(false);
    const [valoresJsonInicial, setValoresJsonInicial] = useState([]);
    const [isVisibleR, setIsVisibleR] = useState(false);
    const [currentView, setCurrentView] = useState('lista');
    const [dataResumen, setDataResumen] = useState([]);
    const [dataResumenPOA, setDataResumenPOA] = useState([]);
    const [mostrarPorcentajes, setMostrarPorcentajes] = useState(false);
    const [openModalMI, setOpenModalMI] = useState(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [participantesFinales, setParticipantesFinales] = useState(false);
    const [modeRepo, setModeRepo] = useState('full');
    const [isModalVisibleInformeTecnico, setIsModalVisibleInformeTecnico] = useState(false);
    const exportPoaRef = useRef();

    //Plan Operativo Drawer
    const [openPlanOperativo, setOpenPlanOperativo] = useState(false)

    const showDrawerPlanOperativo = () => setOpenPlanOperativo(true)
    const handleClosePlanOperativo = () => setOpenPlanOperativo(false)

    //Infraestructura
    const [isModalOpenInfra, setIsModalOpenInfra] = useState(false);
    const [avanceInfraestructura, setAvanceInfraestructura] = useState(null);

    //Control de Permisos
    const appName = 'planOperativo';
    const permissions = useSelector((state) => selectAppPermissions(state, appName));
    const permissionPrint = permissions.priv_print === 'Y';
    const permissionExport = permissions.priv_export === 'Y';
    const permissionUpdate = permissions.priv_update === 'Y';
    const permissionInsert = permissions.priv_insert === 'Y';

    const permissionsInformeTecnico = useSelector((state) => selectAppPermissions(state, 'informe_tecnico_final'));
    const permissionInformeTecnico = permissionsInformeTecnico.priv_access === 'Y';

    const applications = useSelector(selectUserApplications);

    // Mapeo oid del componente (po_componentes) -> app_name en sec_apps
    const COMPONENTE_APP_MAP = {
        0: 'documento-factibilidad-actualizado-pdf',
        1: 'plan-operativo-actividades',
        3: 'participantes',
        4: 'visitas_seguimiento',
        5: 'sesiones_eca',
        6: 'actas_entrega',
        7: 'sistematizacionIppta',
        8: 'encuesta_EDAH',
        9: 'acuerdos-comerciales',
        10: 'ManifestacionInteres',
        11: 'poa-infraestructura',
        13: 'plan_pedagogico',
        14: 'proyecto_extension_poa',
        15: 'informe_final_poa',
        16: 'nuevos_participantes',
        17: 'contrapartida',
        18: 'novedad_participante',
        19: 'ecas_participante',
    };

    const componentesFiltrados = componentes.filter(item => {
        const appNameComponente = COMPONENTE_APP_MAP[item.oid];
        if (!appNameComponente) return true;
        const perm = applications.find(app => app.app_name === appNameComponente);
        return perm?.priv_access === 'Y';
    });

    const onCloseDrawable = () => {
        setOpenDrawer(false);
        regresarModal();
    };


    useEffect(() => {
        const fetchProjects = async () => {
            try {
                setLoading(true);
                const { data } = await getProyectosPO();
                const dataJSONPesoResumen = await getPOPesoResumen();
                setDataResumenPOA(dataJSONPesoResumen.data);
                setProjects(data);
            } catch (error) {
                console.error("Error fetching projects:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProjects();
    }, [id, mostrarPorcentajes]);




    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                if (
                    isValid(id) &&
                    participanteFinal === "participanteFinales"
                ) {
                    setOpcionFiltro(1);
                    setParticipantesFinales(true);
                    setCodigoProyecto(id);
                    setIsModalVisibleParticipantes(true);

                } else if (isValid(id) && novedades === "novedades") {
                    setOpcionFiltro(5);
                    setCodigoProyecto(id);
                    setIsModalVisibleParticipantes(true);
                } else if (isValid(id) && ecasParticipante === "ecasParticipante") {
                    setOpcionFiltro(6);
                    setCodigoProyecto(id);
                    setIsModalVisibleParticipantes(true);
                } else if (
                    isValid(id) &&
                    manifestacionInteres === "manifestacionInteres"
                ) {
                    setCodigoProyecto(id);
                    setOpenModalMI(true);
                } else if (isValid(id) && documentoSoporte === "documentoSoporte") {
                    setAvanceInfraestructura(3);
                    setEstadoIniciar(true);
                    setCodigoProyecto(id);
                    handleOpenModalInfra();
                } else if (
                    isValid(id) &&
                    isValid(tarea) &&
                    tarea === "2.1.4" &&
                    infraestructura === "infraestructura" &&
                    infraestructuraItem === "formatoverificacion"
                ) {
                    setAvanceInfraestructura(2);
                    setEstadoIniciar(true);
                    setCodigoProyecto(id);
                    handleOpenModalInfra();

                } else
                    if (isValid(id) && isValid(tarea) && id && tarea === "2.1.4" && infraestructura === "infraestructura") {
                        setAvanceInfraestructura(1);
                        setEstadoIniciar(true);
                        setCodigoProyecto(id);
                        handleOpenModalInfra();

                    } else if (isValid(id) && !isValid(tarea) && id && infraestructura === "infraestructura") {
                        setEstadoIniciar(false);
                        setCodigoProyecto(id);
                        handleOpenModalInfra();
                    } else if (isValid(id) && isValid(tarea) && id && tarea !== "2.1.4") {
                        await abrirFileManagerParaTarea(id, tarea);
                    } else if (isValid(id) && isValid(tarea) && id && tarea === "2.1.4") {
                        //Actualmente se deja para la p32 que posee icono verde en su plan operativo
                        await abrirFileManagerParaTarea(id, tarea);
                    } else if (!id) return;

                const { data } = await getProyectosPO();
                const proyectoEncontrado = data.find(
                    (proyecto) => proyecto.codigo === id
                );

                if (proyectoEncontrado) {
                    setProjects(data);
                    handleOpenModal(proyectoEncontrado);
                    setBanderaLink(true);
                } else {
                    message.warning(`El proyecto ${id} no existe.`);
                    setProjects(data);
                    setBanderaLink(false);
                }
            } catch (error) {
                console.error("❌ Error general en fetchData:", error);
                message.error("Ocurrió un error al obtener los datos.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id, tarea, infraestructura, infraestructuraItem]);


    useEffect(() => {
        const fetchData = async () => {
            if (!codProyecto) return;
            setLoadingComponentes(true);
            setSelectedComponent(null);
            try {
                const response = await getComponentesPO(codProyecto);
                if (id && banderaLink) {
                    const componenteEncontrado = response.data.find(componente => componente.oid === 1);
                    setSelectedComponent(componenteEncontrado);
                    setComponentes(response.data);
                } else {
                    setComponentes(response.data);
                }
            } catch (error) {
                console.error("Error fetching components:", error);
            } finally {
                setLoadingComponentes(false);
            }
        };
        fetchData();
    }, [banderaLink, codProyecto, id]);





    const hideModal = () => {
        setIsModalVisibleFileManager(false);
        setDataFilterProyecto(null);
        setEsInformeFinalFileManager(false);
    };

    // Busca el árbol de una tarea puntual del POA (código conocido, ej.
    // "2.1.4") para un proyecto y abre FileManagerPP con lo encontrado.
    // Usado por el deep-link de URL (/planOperativo/{codigo}/{tarea}).
    const abrirFileManagerParaTarea = async (codigoProyecto, tareaCodigo) => {
        const cleanId = codigoProyecto.replace(/^P/, "");
        const response = await getDirectoryTreePoaPP(cleanId, tareaCodigo);
        setEsInformeFinalFileManager(false);
        if (
            response.status === 200 &&
            Array.isArray(response.data) &&
            response.data.length > 0
        ) {
            setDataFilterProyecto(response.data);
            setIsModalVisibleFileManager(true);
        } else {
            setDataFilterProyecto([]);
            setIsModalVisibleFileManager(false);
            message.warning("No se encontraron datos para la tarea seleccionada.");
        }
    };

    // Abre FileManagerPP con la documentación del Informe Técnico Final
    // (tarjeta "Informe Final" del menú del proyecto). El código de tarea que
    // lo contiene varía por proyecto (4.1.1 a 4.1.6 según su estructura de
    // POA), así que se busca por el texto del indicador en vez de un código
    // fijo — mismo criterio que usa InformeTecnicoFinalPage.jsx.
    const abrirInformeFinal = async (codigoProyecto) => {
        const response = await getInformeFinalPlanOperativo(codigoProyecto);
        if (
            response.status === 200 &&
            Array.isArray(response.data) &&
            response.data.length > 0
        ) {
            setDataFilterProyecto(response.data);
            setEsInformeFinalFileManager(true);
            setIsModalVisibleFileManager(true);
        } else {
            setDataFilterProyecto([]);
            setEsInformeFinalFileManager(false);
            setIsModalVisibleFileManager(false);
            message.warning("No se encontraron datos del Informe Técnico Final para este proyecto.");
        }
    };

    function logTotPesoPorMesAnioPorFase(dataJSONPeso) {
        const acumuladoresPorFase = {};
        dataJSONPeso.forEach((fase) => {
            const faseId = fase.fase_id || "fase-sin-id";
            if (!acumuladoresPorFase[faseId]) {
                acumuladoresPorFase[faseId] = {
                    P: {},
                    E: {},
                };
            }
            if (!fase.children) return;
            fase.children.forEach((tarea) => {
                const pesoEntero = parseFloat(tarea.pesoPorcentual) || 0;
                const peso = pesoEntero / 1;
                if (!tarea.children) return;
                tarea.children.forEach((indicador) => {
                    const meta = parseFloat(indicador.meta) || 0;
                    if (meta <= 0 || peso <= 0) return;
                    if (indicador.cronogramasP) {
                        indicador.cronogramasP.forEach((crono) => {
                            const p = parseFloat(crono.avance) || 0;
                            const mes = crono.mes;
                            const ano = crono.ano;
                            const keyMesAnio = `${mes}-${ano}`;
                            const parcial = (p / meta) * peso;
                            if (!acumuladoresPorFase[faseId].P[keyMesAnio]) {
                                acumuladoresPorFase[faseId].P[keyMesAnio] = 0;
                            }
                            acumuladoresPorFase[faseId].P[keyMesAnio] += parcial;
                        });
                    }
                    if (indicador.cronogramasE) {
                        indicador.cronogramasE.forEach((crono) => {
                            const e = parseFloat(crono.avance) || 0;
                            const mes = crono.mes;
                            const ano = crono.ano;
                            const keyMesAnio = `${mes}-${ano}`;
                            const parcial = (e / meta) * peso;
                            if (!acumuladoresPorFase[faseId].E[keyMesAnio]) {
                                acumuladoresPorFase[faseId].E[keyMesAnio] = 0;
                            }
                            acumuladoresPorFase[faseId].E[keyMesAnio] += parcial;
                        });
                    }
                });
            });
        });
        for (const faseId in acumuladoresPorFase) {
            for (const tipo of ["P", "E"]) {
                for (const keyMesAnio in acumuladoresPorFase[faseId][tipo]) {
                    const valorAcumulado = acumuladoresPorFase[faseId][tipo][keyMesAnio];
                    acumuladoresPorFase[faseId][tipo][keyMesAnio] = Number(
                        valorAcumulado.toFixed(2)
                    );
                }
            }
        }
        const resultado = { fases: [] };
        for (const [faseId, objPE] of Object.entries(acumuladoresPorFase)) {
            resultado.fases.push({
                fase: faseId,
                p: objPE.P,
                e: objPE.E,
            });
        }
        return resultado;
    }
    const toggleVisibilityDetalle = () => {
        setIsVisibleR(!isVisibleR);
    };

    const filteredProjects = projects.filter((project) =>
        project.proyecto.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleOpenModal = async (project) => {
        setCodProyecto(project.oid);
        setSelectedProject(project);
        setIsModalVisible(true);
        const dataJSONPeso = await getPOPeso(0, project.oid, 'inicial');
        const dataDashboard = await getDataProyectos(project.oid);
        setLoading(true);
        try {
            const { status, data: body } = dataJSONPeso;
            if (status === 200 && body.status === 200 && Array.isArray(body.data)) {
                const pesoArray = body.data;
                const valoresProcesados = logTotPesoPorMesAnioPorFase(pesoArray);
                setValoresJsonInicial(valoresProcesados);
                setDataResumen(dataDashboard.data.dataProyecto);
            } else {
                throw new Error("Los datos de Peso no son válidos");
            }
        } catch (error) {
            console.error("Error al obtener datos de Peso:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
        setIsVisibleR(false);
        setCurrentView('lista');
    };

    const regresarModal = () => {
        setIsModalVisible(true);
        setIsVisibleR(false);
        setCurrentView('lista');
    };

    useEffect(() => {
        if (selectProject) {
            setCodigoProyecto(selectProject.codigo);
        }
    }, [selectProject]);

    const handleCardClick = (component) => {
        setCurrentView('lista');
        if (component.oid === 0) {
            downloadFileHandler();
        } else if (component.oid === 1) {
            setSelectedComponent(component);
            setCurrentView('fase');
        } else if (component.oid === 3) {
            setOpcionFiltro(1);
            setParticipantesFinales(true);
            setCodigoProyecto(selectProject.codigo);
            setIsModalVisibleParticipantes(true);
        } else if (component.oid === 4) {
            procesarMpoa("2.2.1.3") // Visitas
        } else if (component.oid === 5) {
            procesarMpoa("2.2.3") // Ecas
        } else if (component.oid === 6) {
            procesarMpoa("2.1.4") // Actas
        } else if (component.oid === 7) {
            setOpcionFiltro(2);
            setCodigoProyecto(selectProject.codigo);
            setIsModalVisibleParticipantes(true);
        } else if (component.oid === 8) {
            setOpcionFiltro(3);
            setCodigoProyecto(selectProject.codigo);
            setIsModalVisibleParticipantes(true);
        } else if (component.oid === 9) {
            setOpcionFiltro(4);
            setCodigoProyecto(selectProject.codigo);
            setIsModalVisibleParticipantes(true);
        } else if (component.oid === 13) {
            setCodigoProyecto(selectProject.codigo);
            setModeRepo("planesPedagogicos")
            setOpenDrawer(true);
            handleCloseModal();
        } else if (component.oid === 10) {
            setCodigoProyecto(selectProject.codigo);
            setOpenModalMI(true);
        } else if (component.oid === 11) {
            setEstadoIniciar(false);
            handleOpenModalInfra();
        } else if (component.oid === 14) {
            procesarMpoa("2.1.2")
        } else if (component.oid === 15) {
            setCodigoProyecto(selectProject.codigo);
            abrirInformeFinal(selectProject.codigo);
        } else if (component.oid === 16) {
            setModeRepo("nuevosParticipantes")
            setCodigoProyecto(selectProject.codigo);
            setOpenDrawer(true);
            handleCloseModal();
        } else if (component.oid === 17) {
            setModeRepo("contrapartida")
            setCodigoProyecto(selectProject.codigo);
            setOpenDrawer(true);
            handleCloseModal();
        } else if (component.oid === 18) {
            setOpcionFiltro(5);
            setCodigoProyecto(selectProject.codigo);
            setIsModalVisibleParticipantes(true);
        } else if (component.oid === 19) {
            setOpcionFiltro(6);
            setCodigoProyecto(selectProject.codigo);
            setIsModalVisibleParticipantes(true);
        }
    };

    const handleOpenModalInfra = () => {
        setIsModalOpenInfra(true);
    };

    const handleCloseInfra = () => {
        setIsModalOpenInfra(false);
        setEstadoIniciar(false);
    };

    const procesarMpoa = async (Mpoa) => {
        if (Mpoa) {
            if (Mpoa === '2.2.1') {
                return null;
            }
            const manejarActividadEspecial = (actividad) => {
                switch (actividad) {
                    case '2.2.1.1':
                        return '2.2.1';
                    case '2.2.1.2':
                        return '2.2.1';
                    case '2.2.1.3':
                        return '2.2.1';
                    default:
                        return actividad;
                }
            };
            const actividadBase = manejarActividadEspecial(Mpoa);
            try {
                const dataCompleta = await fetchPoaData();
                const dataPoa = dataCompleta.dataPoa;
                const findNodePath = (node, path = []) => {
                    path.push(node);
                    if (node.codigo_tarea === actividadBase && !['2.2.1.2', '2.2.1.3'].includes(Mpoa)) {
                        return path;
                    }
                    if (['2.2.1.2', '2.2.1.3'].includes(Mpoa)) {
                        if (node.children && node.children.length > 0) {
                            for (let child of node.children) {
                                if (Mpoa === '2.2.1.2' && child.key === 'indicador_33') {
                                    path.push(child);
                                    return path;
                                }
                                if (Mpoa === '2.2.1.3' && child.key === 'indicador_34') {
                                    path.push(child);
                                    return path;
                                }
                            }
                        }
                    }

                    if (node.children && node.children.length > 0) {
                        for (let child of node.children) {
                            const result = findNodePath(child, [...path]);
                            if (result) return result;
                        }
                    }
                    return null;
                };
                let matchedPath = null;

                for (let nodo of dataPoa) {
                    matchedPath = findNodePath(nodo);
                    if (matchedPath) break;
                }
                if (matchedPath) {
                    const initialData = extractData(matchedPath);
                    const actividadData = initialData[0].actividadData;
                    const tareaEncontrada = actividadData.find((item) => {
                        if (['2.2.1.2', '2.2.1.3'].includes(Mpoa)) {
                            return (
                                item.codigo_tarea === actividadBase &&
                                ((Mpoa === '2.2.1.2' && item.key === 'indicador_33') ||
                                    (Mpoa === '2.2.1.3' && item.key === 'indicador_34'))
                            );
                        }
                        return item.codigo_tarea === actividadBase;
                    });
                    if (Mpoa === '2.1.2') {
                        tareaEncontrada.poaConExtension = true;
                    }
                    if (tareaEncontrada) {
                        tareaEncontrada.proyecto = selectProject.codigo;
                        setOpenModalVisitasEcas(true);
                        setItemParams(tareaEncontrada);
                    } else {
                        setOpenModalVisitasEcas(false);
                        setItemParams(null);
                    }
                } else {
                    console.warn("No se encontró ningún nodo coincidente");
                }
            } catch (error) {
                console.error("Error al obtener los datos:", error);
            }
        } else {
            setOpenModalVisitasEcas(false);
        }
    };

    const extractData = (children) => {
        return children.flatMap(child => {
            if (child.children && child.tipo === 'Actividad') {
                const actividadData = child.children.flatMap(grandchild => {
                    if (grandchild.children && grandchild.tipo === 'Tarea') {
                        return grandchild.children.flatMap(greatGrandchild => {
                            if (greatGrandchild.tipo === 'Indicador') {
                                const fecha = greatGrandchild.meta_e?.[0]?.fecha;
                                const fechaFormateada = fecha ? new Date(fecha).toLocaleDateString('es-ES') : '-';
                                const medioV = greatGrandchild.medioVerificacion || null;
                                return {
                                    key: greatGrandchild.key,
                                    codigo_tarea: grandchild.codigo_tarea,
                                    codActividad: grandchild.codActividad,
                                    nameActividad: child.actividad,
                                    tarea: grandchild.tarea,
                                    indicador: greatGrandchild.title,
                                    medioV: medioV,
                                    fechas: fechaFormateada,
                                    responsables: 'N/A',
                                    soportes: 'N/A',
                                    datoIndicador: greatGrandchild,
                                };
                            }
                            return [];
                        });
                    }
                    return [];
                });
                return [{
                    actividadTitle: child.title,
                    actividad: child.actividad,
                    actividadData: actividadData
                }];
            }
            return [];
        });
    };

    const hideModalVisitasEcas = () => {
        setOpenModalVisitasEcas(false);
    };

    const hideModalMI = () => {
        setOpenModalMI(false);
    };

    const handleCancelParticipantes = () => {
        setIsModalVisibleParticipantes(false);
    };

    const downloadFileHandler = async () => {
        const loadingMessage = message.loading('Cargando archivo...', 0);
        try {
            const proyect = selectProject.codigo;
            const ruta = `/DocumentosActualizacion/${proyect}/Proyecto/Factibilidad Actualizada PDF/`;
            await viewFile(ruta);
            loadingMessage();
            message.success('Archivo cargado correctamente!', 2);
        } catch (error) {
            console.error('Error al abrir el archivo:', error);
            loadingMessage();
            message.error('No se encontró el archivo.', 2);
        }
    };

    const handleBackClick = () => {
        setSelectedComponent(null);
        setIsVisibleR(false)
        setCurrentView('lista');
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;

    const handleFaseClick2 = (parentComponent, fase) => {
        setSelectedFase2(fase);
        setIsModalVisible2(true);
        handleCloseModal();
        setSelectedComponent(parentComponent);
        setCurrentView('fase'); // Cambia la vista actual
    };

    const handleCloseModal2 = () => {
        setIsModalVisible2(false);
        setCurrentView('lista')
    };

    const renderComponent = () => {
        switch (opcionFiltro) {
            case 1:
                return <Participantes proyectoCodigo={codigoProyecto} participantesFinales={participantesFinales} />;
            case 2:
                return <Ippta proyectoCodigo={codigoProyecto} />;
            case 3:
                return <Edah proyectoCodigo={codigoProyecto} />;
            case 4:
                return <AcuerdosComerciales proyectoCodigo={codigoProyecto} />;
            case 5:
                return <Novedades proyectoCodigo={codigoProyecto} />;
            case 6:
                return <EcasParticipante proyectoCodigo={codigoProyecto} />;
            default:
                return null;
        }
    };

    const menuItems = [
        {
            key: "conDatos",
            label: "Descargar en formato Excel",
            onClick: () => exportPoaRef.current.exportToExcel(1)
        },
        permissionUpdate && {
            key: "sinDatos",
            label: "Descargar POA inicial",
            onClick: () => exportPoaRef.current.exportToExcel(2)
        }
    ].filter(Boolean);


    return (
        <div className="container">
            <Layout>
                <div className="row mb-2 d-flex align-items-center">
                    <div className="col-md-8 linea_separador mb-2 d-flex align-items-center">
                        <div className="titulo_proyecto" style={{ flexBasis: '25%', flexGrow: 0 }}>
                            <p>PROYECTO UTF <br /> COL 160 COL</p>
                        </div>
                        <div className="objeto" style={{ flexBasis: '75%', flexGrow: 0 }}>
                            <p>
                                Implementar actividades de desarrollo económico, derecho humano a la alimentación y fortalecimiento de capacidades
                                institucionales, comunitarias y organizacionales que aporten al cierre de brechas y la transformación de los territorios PDET
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4 d-flex justify-content-center align-items-center flex-column">
                        <h2 className="text-center mb-2">Implementación</h2>
                        <div className="d-flex flex-column align-items-center gap-2">
                            <div className="d-flex justify-content-center align-items-center flex-row gap-2">
                                {permissionExport && (
                                    <Button
                                        onClick={() => setMostrarPorcentajes(!mostrarPorcentajes)}
                                        type="primary"
                                        style={{ height: 40, width: 180, fontWeight: "500", }}>
                                        {mostrarPorcentajes
                                            ? "Volver a la Vista Principal" : "% de Avance POA´s"}
                                    </Button>
                                )}
                                {permissionInsert && (
                                    <Button
                                        onClick={showDrawerPlanOperativo}
                                        icon={<BarChartOutlined />}
                                        type="primary"
                                        style={{ height: 40, width: 180, fontWeight: "500", }} >
                                        Reporte POA´s
                                    </Button>)}
                            </div>
                            {permissionInformeTecnico && (
                                <Button
                                    onClick={() => setIsModalVisibleInformeTecnico(true)}
                                    icon={<FilePdfOutlined />}
                                    type="primary"
                                    style={{ height: 40, width: 180, fontWeight: "500", }}
                                >
                                    Informe Técnico Final
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
                {mostrarPorcentajes ? (
                    <div>
                        <PoaResumen data={dataResumenPOA?.data} />
                    </div>
                ) : (
                    <>
                        <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                            <Col span={24}>
                                <Input
                                    placeholder="Buscar por nombre"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{ width: 400, height: 40, marginRight: 8 }}
                                />
                                <Button
                                    onClick={() => setSearchTerm("")}
                                    type="primary"
                                    style={{ height: 40 }}
                                >
                                    Limpiar Filtro
                                </Button>
                            </Col>
                        </Row>
                        <Row gutter={[16, 16]} className="proyecto-card-unique-row">
                            {loading ? (
                                <div>Cargando proyectos...</div>
                            ) : (
                                filteredProjects.map((project) => (
                                    <Col key={project.oid} xs={24} sm={12} md={8} lg={8} xl={6} className="proyecto-card-unique-col">
                                        <Card
                                            className="card-menu h-100 redondear card-header align-items-center text-center"
                                            style={{
                                                body: {
                                                    height: "100%",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                },
                                            }}
                                        >
                                            <div
                                                style={{
                                                    height: "60px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    padding: "10px",
                                                    textAlign: "center",
                                                    borderRadius: "5px",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                <div >
                                                    <h6 className="card-title fw-bold fs-8 m-0" style={{ color: '#FFF !important' }}>{project.proyecto}</h6>
                                                    <p className="card-text"><small className="codproyecto">Código: {project.codigo}</small></p>
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    flex: 1,
                                                    width: "100%",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                <Row gutter={16} style={{ width: "100%", justifyContent: "center" }}>
                                                    <div className="col-md-12" style={{ maxHeight: '130px', width: '100%', height: '100%' }}>
                                                        <ImageComponent
                                                            projectId={project.oid} />
                                                    </div>
                                                </Row>
                                            </div>
                                            <div
                                                className="text-muted mt-auto"
                                                style={{
                                                    display: "flex",
                                                    backgroundColor: "#fff",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginTop: "auto",
                                                    padding: "10px",
                                                }}
                                            >
                                                <Tooltip title="Ingresar">
                                                    <Button
                                                        className="m-2 btn-primary-lis"
                                                        onClick={() => handleOpenModal(project)}
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            color: "inherit",
                                                        }}
                                                        icon={<HomeOutlined style={{ fontSize: 20, color: "#1890ff" }} />}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </Card>
                                    </Col>
                                ))
                            )}
                        </Row>
                        {selectProject && (
                            <Drawer
                                title={
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '100%',
                                            position: 'relative',
                                        }}
                                    >
                                        <h4 style={{ margin: 0, fontWeight: 'bold' }}>
                                            {selectProject.codigo} - {selectProject.proyecto}
                                        </h4>

                                        <div>
                                            <Button
                                                icon={<CloseOutlined />}
                                                onClick={handleCloseModal}
                                                style={{
                                                    position: 'absolute',
                                                    right: 0,
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    border: 'none',
                                                    boxShadow: 'none',
                                                }}
                                            />
                                            {selectedComponent && (
                                                <Button
                                                    icon={<ArrowLeftOutlined />}
                                                    onClick={handleBackClick}
                                                    style={{
                                                        position: 'absolute',
                                                        right: 40,
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        border: 'none',
                                                        boxShadow: 'none',
                                                    }}
                                                >
                                                    Regresar
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                }
                                placement="right"
                                onClose={handleCloseModal}
                                open={isModalVisible}
                                width={'100%'}

                            >
                                <div style={{ paddingTop: '20px' }}>
                                    {currentView === 'lista' && (
                                        <div style={{ marginBottom: 24 }}>
                                            <h3 style={{ margin: 0, fontWeight: 500 }}>Selecciona una opción</h3>
                                            <p style={{ margin: 0, color: '#999' }}>
                                                Consulta toda la información disponible del proyecto: revisa el Plan Operativo Anual (POA), visualiza los soportes de las visitas, accede al listado completo de participantes y conoce en detalle las Sesiones ECA´s, entre otros recursos. Con esta sección, tendrás una visión integral del avance y la organización de tu proyecto.
                                            </p>
                                        </div>
                                    )}
                                    {currentView === 'lista' ? (

                                        <List
                                            style={{ padding: '16px' }}
                                            grid={{ gutter: 16, column: 4 }}
                                            dataSource={componentesFiltrados}
                                            renderItem={(item) => {
                                                const isDisabled = item.estado === 2;
                                                return (
                                                    <List.Item
                                                        style={{
                                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                            transition: 'background-color 0.3s ease',
                                                            padding: '12px',
                                                            backgroundColor: isDisabled ? '#d3d3d3' : 'transparent',
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            if (!isDisabled) {
                                                                e.currentTarget.style.backgroundColor = '#f0f0f0';
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (!isDisabled) {
                                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                            }
                                                        }}
                                                        onClick={() => {
                                                            if (!isDisabled) {
                                                                handleCardClick(item);
                                                            }
                                                        }}
                                                    >
                                                        <Tooltip title={item.nombre_largo}>
                                                            <List.Item.Meta
                                                                avatar={
                                                                    <Avatar
                                                                        shape="square"
                                                                        style={{
                                                                            backgroundColor: item.color || '#d3d3d3',
                                                                            width: 64,
                                                                            height: 64,
                                                                            fontSize: 20,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            color: '#000',
                                                                        }}
                                                                    >
                                                                        {item.sigla}
                                                                    </Avatar>
                                                                }
                                                                title={
                                                                    item.oid === 11
                                                                        ? [6, 7, 13, 14, 15, 19, 26, 29, 32].includes(selectProject.oid)
                                                                            ? item.nombre_corto + '\n(No aplica)'
                                                                            : item.nombre_corto
                                                                        : item.nombre_corto
                                                                }
                                                                description={
                                                                    item.oid === 11
                                                                        ? [6, 7, 13, 14, 15, 19, 26, 29, 32].includes(selectProject.oid)
                                                                            ? item.descripcion + '\n El proyecto no contempla infraestructura'
                                                                            : item.descripcion
                                                                        : item.descripcion
                                                                }
                                                            />
                                                        </Tooltip>
                                                    </List.Item>
                                                );
                                            }}
                                        />
                                    ) : (
                                        <div style={{ marginBottom: 24, width: '100%' }}>
                                            <div style={{ marginBottom: 24 }}>
                                                <h3 style={{ margin: 0, fontWeight: 500 }}>Plan Operativo Anual (POA)</h3>
                                                <p style={{ margin: 0, color: '#999' }}>
                                                    Accede a la información disponible del Plan Operativo Anual (POA)
                                                </p>
                                            </div>
                                            <Row gutter={[16, 16]}>
                                                {selectedComponent?.fases?.length > 0 ? (
                                                    selectedComponent.fases.map((fase) => (
                                                        <Col xs={24} sm={12} md={8} key={fase.oid}>
                                                            <Tooltip
                                                                styles={{
                                                                    root: fase.estado === 2 ? { minWidth: "76em" } : {}
                                                                }}
                                                                title={fase.estado === 2 ? fase.comentario : fase.nombre_corto}
                                                                color={fase.estado === 2 ? "#000" : "blue"}
                                                            >
                                                                <Card
                                                                    hoverable={fase.estado !== 2}
                                                                    style={{
                                                                        borderRadius: "12px",
                                                                        textAlign: "center",
                                                                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                                                        cursor: fase.estado === 2 ? "not-allowed" : "pointer",
                                                                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                                                        paddingTop: '15px',
                                                                    }}
                                                                    onClick={() =>
                                                                        fase.estado !== 2 && handleFaseClick2(selectedComponent, fase)
                                                                    }
                                                                    onMouseEnter={(e) => {
                                                                        if (fase.estado !== 2) {
                                                                            e.currentTarget.style.transform = "translateY(-4px)";
                                                                            e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.2)";
                                                                        }
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.transform = "translateY(0)";
                                                                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            width: "80px",
                                                                            height: "80px",
                                                                            borderRadius: "50%",
                                                                            margin: "0 auto 10px",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            fontSize: "24px",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: fase.estado === 2 ? "#d3d3d3" : fase.color,
                                                                            color: "#000",
                                                                        }}
                                                                    >
                                                                        {fase.sigla}
                                                                    </div>
                                                                    <h5 style={{ margin: "0 0 8px" }}>{fase.nombre_corto}</h5>
                                                                    <p style={{ color: "gray", margin: 0, fontSize: "14px" }}>
                                                                        {fase.nombre_largo}
                                                                    </p>
                                                                </Card>
                                                            </Tooltip>
                                                        </Col>

                                                    ))
                                                ) : (
                                                    <div>No hay fases disponibles</div>
                                                )}
                                            </Row>
                                            <Row justify="left" style={{ marginBottom: "20px", marginTop: '20px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <h3 style={{ margin: 0 }}>Resumen de avance</h3>
                                                    <Tooltip title="Mostrar u ocultar el resumen de avance en la ejecución.">
                                                        <TableOutlined
                                                            style={{
                                                                marginLeft: '16px',
                                                                color: toggleVisibilityDetalle ? 'green' : 'gray',
                                                                fontSize: '20px'
                                                            }}
                                                            onClick={toggleVisibilityDetalle}
                                                        />
                                                    </Tooltip>
                                                </div>
                                                {isVisibleR && (
                                                    loading ? (
                                                        <Spin tip="Cargando..." />
                                                    ) : (
                                                        <div style={{ overflowX: 'auto' }}>
                                                            <TablaAvanceJSX valoresJsonPeso={valoresJsonInicial} modo="inicial" />
                                                        </div>
                                                    )
                                                )}
                                            </Row>
                                            <Row justify="center" style={{ marginBottom: "20px" }}>
                                                <Space>
                                                    <Button
                                                        icon={<ArrowLeftOutlined />}
                                                        onClick={handleBackClick}
                                                        type="default"
                                                        style={{ height: 40, width: 150 }}
                                                    >
                                                        Regresar
                                                    </Button>
                                                    <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
                                                        <Button
                                                            type="primary"
                                                            icon={<FileExcelOutlined />}
                                                            style={{ width: 150, height: 40, display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                                        >
                                                            Descargar POA
                                                        </Button>
                                                    </Dropdown>
                                                </Space>
                                                <ExportPoa
                                                    ref={exportPoaRef}
                                                    selectedProject={codProyecto}
                                                    valoresJsonPeso={valoresJsonInicial}
                                                />
                                            </Row>

                                        </div>
                                    )}
                                    {permissionPrint && (
                                        <>
                                            {dataResumen && Object.keys(dataResumen).length > 0 && currentView === 'lista' ? (
                                                <DashboardPlanOperativo dataProyecto={dataResumen} codigoProyecto={selectProject.oid} />
                                            ) : (
                                                <>
                                                    {currentView === 'lista' && (
                                                        <p>Dashboard.</p>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </Drawer >
                        )}
                    </>)}
                <Modal
                    title=""
                    open={isModalVisible2}
                    onCancel={handleCloseModal2}
                    footer={null}
                    width="95%"
                    style={{ top: 10 }}
                    destroyOnHidden={true}
                >
                    <PoaPlanOperativoTB selectedFase={selectedFase2} selectedProject={selectProject} regresarAnterior={regresarModal} cerrarModal={handleCloseModal2} />
                </Modal>
                <Modal
                    title=""
                    open={isModalVisibleParticipantes}
                    onCancel={handleCancelParticipantes}
                    footer={null}
                    width="95%"
                    style={{ top: 10 }}
                    destroyOnHidden={true}
                    zIndex={2000}
                >
                    {renderComponent()}
                </Modal>
                <div className="d-flex justify-content-center">
                    <Modal
                        title={<span className="custom-modal-title">Medios de verificación</span>}
                        open={openModalVisitasEcas}
                        onCancel={hideModalVisitasEcas}
                        destroyOnHidden={true}
                        footer={null}
                        width="95%"
                        style={{ top: 20 }}
                    >
                        <FileManagerPOA codigo_tarea={{ codigo_tarea: itemParams }} onClose={hideModalVisitasEcas} />
                    </Modal>
                </div>
                <div id="exportable-section">
                    {codigoProyecto && openDrawer && <RepositorioDocumento open={openDrawer} onCloseMetodo={onCloseDrawable} proyectoCodigo={codigoProyecto} mode={modeRepo} />}
                </div>
                <div className="d-flex justify-content-center">
                    <Modal
                        title={<span className="custom-modal-title">Manifestación de Interés</span>}
                        open={openModalMI}
                        onCancel={hideModalMI}
                        footer={null}
                        width="95%"
                        style={{ top: 20 }}
                        destroyOnHidden={true}
                        zIndex={2000}
                        styles={{
                            mask: {
                                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                            },
                        }}
                    >
                        {selectProject !== null ? (
                            <ManifestacionInteres
                                proyectoCodigo={codProyecto}
                                codP={selectProject.codigo}
                                nameP={selectProject.proyecto}
                            />
                        ) : (
                            <Spin />
                        )}
                    </Modal>
                    <InfraestructuraModal isOpen={isModalOpenInfra} onClose={handleCloseInfra} proyecto={codigoProyecto} estadoIniciar={estadoIniciar} avanceInfraestructura={avanceInfraestructura} />
                </div>
                <div className="d-flex justify-content-center">
                    <Modal
                        title={<span className="custom-modal-title">Medios de verificación</span>}
                        open={isModalVisibleFileManager}
                        onCancel={hideModal}
                        destroyOnHidden={true}
                        footer={null}
                        width="95%"
                        style={{ top: 20 }}
                        zIndex={2000}
                    >
                        {Array.isArray(dataFilterProyecto) && dataFilterProyecto.length > 0 ? (
                            <FileManagerPP
                                codigo_tarea={{
                                    proyecto: dataFilterProyecto[0]?.pp,
                                    codActividad: dataFilterProyecto[0]?.codigo_actividad,
                                    actividad: dataFilterProyecto[0]?.descripcion,
                                    codTarea: dataFilterProyecto[0]?.codigo_tarea,
                                    tarea:
                                        dataFilterProyecto[0]?.codigo_tarea +
                                        " - " +
                                        dataFilterProyecto[0]?.tarea_descripcion,
                                    codIndicador: dataFilterProyecto[0]?.indicador_id,
                                    indicador: dataFilterProyecto[0]?.indicador,
                                    codMV: dataFilterProyecto[0]?.medio_verificacion_id,
                                    medioVerificacion: dataFilterProyecto[0]?.medio_verificacion,
                                }}
                                select_proyect={dataFilterProyecto}
                                esInformeFinal={esInformeFinalFileManager}
                            />
                        ) : (
                            <p>No hay información para mostrar</p>
                        )}

                    </Modal>
                </div>
                <Drawer
                    title={
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                gap: 4,
                                borderRadius: "8px 8px 0 0",
                            }}
                        >
                            <Title
                                level={4}
                                style={{
                                    color: "white",
                                    margin: 0,
                                    fontWeight: 700,
                                    fontSize: "1.05rem",
                                }}
                            >
                                Reporte Plan Operativo
                            </Title>
                            <Text
                                style={{
                                    color: "rgba(255,255,255,0.85)",
                                    fontSize: "0.9rem",
                                    marginTop: 2,
                                }}
                            >
                                Sistema de seguimiento y análisis de indicadores institucionales
                            </Text>
                        </div>
                    }
                    placement="left"
                    open={openPlanOperativo}
                    onClose={handleClosePlanOperativo}
                    destroyOnHidden={true}
                    width="100vw"
                >
                    {openPlanOperativo && <ProjectDashboard />}
                </Drawer>
                <Modal
                    title={null}
                    open={isModalVisibleInformeTecnico}
                    onCancel={() => setIsModalVisibleInformeTecnico(false)}
                    footer={null}
                    width="95%"
                    style={{ top: 10 }}
                    styles={{ body: { minHeight: "85vh" } }}
                    destroyOnHidden
                >
                    {isModalVisibleInformeTecnico && <InformeTecnicoFinalPage />}
                </Modal>
            </Layout >
        </div >
    );
};
export default PoaPlanOperativo;
